import { Button, TextButton } from '@creditornot/cb-button';
import { AlchemyStar } from '@creditornot/cb-icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { Image } from 'apis/asset-repository-service/types';
import { useListingManagerRoutes } from 'modules/shared-menu/hooks/useListingManagerRoutes';

import { ImageGalleryBrowseImages } from '../components/ImageGalleryBrowseImages';
import { useImageGalleryContext } from '../contexts/ImageGalleryContext';
import { useListingManagerImageGalleryFeatureFlag } from '../hooks/useListingManagerImageGalleryFeatureFlag';

const DeselectButton = styled(TextButton)`
  color: ${color.textSubdued};
  padding: 2px 8px;
`;

const ActionButton = styled(Button)`
  border-radius: 6px;
`;

export const BrowseImagesPage = () => {
  const history = useHistory();
  const { selectedImages, toggleSelection, isAnyImageSelected, deselectAll } = useImageGalleryContext();
  const { isListingManagerImageGalleryEditEnabled } = useListingManagerImageGalleryFeatureFlag();
  const { menuEditorImageGalleryEditImagesPage } = useListingManagerRoutes();

  const handleImageCardClick = (asset: Image) => {
    if (isListingManagerImageGalleryEditEnabled) {
      toggleSelection(asset);
    }
  };

  return (
    <ImageGalleryBrowseImages
      headerContent={
        <>
          {isAnyImageSelected && (
            <DeselectButton onClick={deselectAll}>
              <FormattedMessage id="shared-menu.editor.image-gallery.browse-images.deselect-images" />
            </DeselectButton>
          )}
          {isListingManagerImageGalleryEditEnabled && (
            <ActionButton
              variant="primary"
              size="tiny"
              icon={<AlchemyStar />}
              disabled={!isAnyImageSelected}
              onClick={() => history.push(menuEditorImageGalleryEditImagesPage())}
            >
              <FormattedMessage id="shared-menu.editor.image-gallery.browse-images.edit.improve-with-ai" />
            </ActionButton>
          )}
        </>
      }
      onImageCardClick={handleImageCardClick}
      selectedImagesIds={isListingManagerImageGalleryEditEnabled ? selectedImages.map(img => img.id) : []}
      hasAddToOfferAction
    />
  );
};
